import {
  ButtonDatum,
  ButtonSelection,
  DragEvent as D3DragEvent,
} from "app/core/components/dashboard/d3/types"
import { SvgEventHandlers } from "./types"
import * as aspect from "app/core/components/dashboard/d3/aspect"
import * as button from "app/core/components/dashboard/d3/button"
import * as resizers from "app/core/components/dashboard/d3/resizers"
import * as screen from "app/core/components/dashboard/d3/screen"
import * as snap from "app/core/components/dashboard/d3/snap"
import * as svg from "app/core/components/dashboard/d3/svg"
import * as d3 from "d3"

export const register = (
  event: D3DragEvent,
  d3ResizerElement: ButtonSelection,
  d3ButtonElement: ButtonSelection,
  handlers?: SvgEventHandlers,
) => {
  // TODO: resize handling for multiple selection
  const otherButtons = svg
    .buttons()
    .filter<SVGGElement>(
      (datum: ButtonDatum) => datum.uuid !== d3ButtonElement.attr("uuid"),
    ) as d3.Selection<SVGGElement, ButtonDatum, HTMLElement | SVGSVGElement, any> as ButtonSelection
  const snapInfo = snap.init(otherButtons)
  d3ButtonElement.classed("resizing", true)
  d3ResizerElement.classed("resizing", true)
  const dragDirections = {
    top: d3ResizerElement.classed("top"),
    right: d3ResizerElement.classed("right"),
    bottom: d3ResizerElement.classed("bottom"),
    left: d3ResizerElement.classed("left"),
  }
  const dimensions =
    d3ButtonElement.size() === 1 &&
    d3ButtonElement.attr("image-width") &&
    d3ButtonElement.attr("image-height")
      ? {
          width: Number(d3ButtonElement.attr("image-width")),
          height: Number(d3ButtonElement.attr("image-height")),
        }
      : undefined
  const originalPosition = { x: event.x, y: event.y }
  let originalDatum = d3ButtonElement?.datum()
  event
    .on("drag", function (event: DragEvent) {
      const dragOffset = {
        top: dragDirections.top ? -(event.y - originalPosition.y) : 0,
        right: dragDirections.right ? event.x - originalPosition.x : 0,
        bottom: dragDirections.bottom ? event.y - originalPosition.y : 0,
        left: dragDirections.left ? -(event.x - originalPosition.x) : 0,
      }
      let proposedPosition = {
        ...originalDatum,
        ...resizers.calculateResize(originalDatum, dragOffset),
      }

      if (dimensions) {
        proposedPosition = {
          ...proposedPosition,
          ...aspect.enforce(proposedPosition, dragDirections, dimensions),
        }
      } else {
        proposedPosition = {
          ...proposedPosition,
          ...snap.update(snapInfo, proposedPosition, dragDirections),
        }
      }

      const snappedPositionConstrainedToScreen = screen.constrainPosition(proposedPosition)

      d3ButtonElement.datum({
        ...originalDatum,
        ...snappedPositionConstrainedToScreen,
      })
      button.computeAllAttributes(d3ButtonElement)
    })
    .on("end", function (event) {
      snap.done(snapInfo)

      d3ButtonElement.classed("resizing", false)
      d3ResizerElement.classed("resizing", false)
      const updatedDatum = resizers.snapToGridAfterResize(d3ButtonElement, dragDirections)

      const didResize =
        updatedDatum.x !== originalDatum.x ||
        updatedDatum.y !== originalDatum.y ||
        updatedDatum.width !== originalDatum.width ||
        updatedDatum.height !== originalDatum.height

      if (didResize) {
        handlers?.resize?.(d3ButtonElement, event)
      }
    })
}
